import React, { useContext, useEffect, useState } from 'react'
import { CButton, CButtonGroup, CCol, CFormInput, CFormSelect, CRow } from '@coreui/react'
import './template.scss'
import { AppContext } from 'src/views/context/app'
import EditIcon from '../../assets/edit-icon.svg'
import { formatBytes, getThumbnail, getVideoThumbnail } from 'src/views/utils/helper'
import { GlobalContext } from 'src/views/context/GlobalState'
import ImageNotFound from '../../assets/image-not-found.jpg'
import AssetManagerNew from 'src/views/container/AssetManager/AssetManagerNew'
import moment from 'moment'
import { isEmpty } from 'lodash'
import Icon8K from '../../assets/videoQuality/8k-icon.png'
import Icon4K from '../../assets/videoQuality/4k-icon.png'
import Icon2K from '../../assets/videoQuality/2k-icon.png'
import Icon1080P from '../../assets/videoQuality/1080p-icon.png'
import Icon720P from '../../assets/videoQuality/720p-icon.png'
import Icon480P from '../../assets/videoQuality/480p-icon.png'
import Icon360P from '../../assets/videoQuality/360p-icon.png'

const AttachContent = ({
  title = 'Assign a Video',
  linkData,
  setLinkData,
  id = '',
  astrick = false,
  selectorWidth = '68%',
  disabled = false,
}) => {
  const { userSessionObj } = useContext(GlobalContext)
  const { setContentModalNewProps, setIptvModalProps, accountObj } = useContext(AppContext)
  const [selectedEntity, setSelectedEntity] = useState('')
  const [showAssetManager, setShowAssetManager] = useState(false)

  const ResolutionsIcon = {
    360: Icon360P,
    480: Icon480P,
    720: Icon720P,
    1080: Icon1080P,
    2048: Icon2K,
    3840: Icon4K,
    7680: Icon8K,
  }

  useEffect(() => {
    if (linkData?.type !== 'TRAILER') {
      setSelectedEntity(linkData?.type)
    }
  }, [linkData])

  const onLinkTypeChange = (event) => {
    const { value } = event.target
    setSelectedEntity('')
    if (value === 'TRAILER') {
      setShowAssetManager(true)
      setLinkData({ type: 'TRAILER', data: {} })
      return
    }
    setLinkData({ type: '', data: {} })
  }

  const onSelectOptionChange = (value) => {
    setSelectedEntity(value)
    if (value === 'CONTENT' || value === 'IPTV') {
      openModal(value)
    }

    setLinkData({ type: value, data: {} })
  }

  const openModal = (type, id = '') => {
    if (type === 'CONTENT') {
      setContentModalNewProps({
        type: 'single',
        mappedContentId: id,
        mappedContentArray: [],
        selectCallback: (contentId, contents) => {
          let data = {
            id: contentId,
            title: contents[0]?.title,
            description: contents[0]?.description,
            thumbnail: contents[0]?.thumbnail?.website?.s3_key,
            content_type: contents[0]?.video_type,
            other: [
              { name: 'Type', value: contents[0]?.video_type || '--' },
              { name: 'Category', value: contents[0]?.category[0]?.name },
              {
                name: 'Size',
                value: contents[0]?.source_asset
                  ? ['LIVE', 'MPVP'].includes(contents[0]?.video_type)
                    ? '-'
                    : formatBytes(contents[0]?.source_asset?.file_metadata?.file_size)
                  : '--',
              },
            ],
          }
          setLinkData({
            type: type,
            data: data,
          })
        },
      })
    }

    if (type === 'IPTV') {
      setIptvModalProps({
        mappedChannelId: id,
        selectCallback: (channelObj) => {
          setLinkData({
            type: type,
            data: {
              id: channelObj._id,
              title: channelObj?.name,
              description: channelObj?.description,
              thumbnail: channelObj?.thumbnail?.website?.s3_key,
              other: [],
            },
          })
        },
      })
    }
  }

  const handleAssetSelect = (info) => {
    setLinkData({
      type: 'TRAILER',
      data: {
        id: info.asset_id,
        title: info?.file_name,
        thumbnail: info?.asset_id,
        size: info?.file_metadata?.file_size ? formatBytes(info?.file_metadata?.file_size) : '',
        uploadedDate: info?.updated_at ? moment.unix(info?.updated_at).format('DD MMMM YYYY') : '',
        progress: info?.progress,
      },
    })
  }

  return (
    <>
      <CRow className="mt-1 mb-3">
        <div className="d-flex justify-content-between align-items-center ">
          {title && (
            <h6 style={{ fontSize: '13px' }}>
              {title} {astrick && <span style={{ color: 'red' }}>*</span>}
            </h6>
          )}
          <div
            style={{ width: title ? selectorWidth : '100%' }}
            className="d-flex align-items-center"
          >
            <CButtonGroup role="group">
              <CButton
                className={`${
                  linkData?.type !== 'TRAILER' ? 'btn-attach-link-active' : 'btn-attach-link'
                } btn-attach-link  btn-focus-none`}
                name={`entity${id}`}
                id={`entity${id}`}
                value={`ENTITY`}
                disabled={disabled}
                onClick={(e) => onLinkTypeChange(e)}
              >
                Select Entity
              </CButton>
              <CButton
                className={`${
                  linkData?.type === 'TRAILER' ? 'btn-attach-link-active' : 'btn-attach-link'
                } btn-focus-none`}
                name={`trailer${id}`}
                id={`trailer${id}`}
                value={`TRAILER`}
                checked={linkData?.type === 'TRAILER'}
                onClick={(e) => onLinkTypeChange(e)}
                disabled={disabled}
              >
                Select Trailer
              </CButton>
            </CButtonGroup>
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol>
          {linkData?.type !== 'TRAILER' ? (
            <CFormSelect
              placeholder="Select Entity"
              value={selectedEntity}
              onChange={(e) => onSelectOptionChange(e.target.value)}
              style={{ fontSize: '13px' }}
              disabled={disabled}
            >
              <option value="" selected disabled>
                Select Entity
              </option>
              <option value={'CONTENT'}>Content (SPV, MPC, LIVE, VOD as LIVE, Playlist)</option>
              <option value={'IPTV'}>IPTV Channel</option>
            </CFormSelect>
          ) : null}
        </CCol>
      </CRow>
      {linkData?.type !== 'TRAILER' && linkData?.data?.title && (
        <CRow className="mt-3">
          <CCol>
            <div className="attach-link-box flex position-relative">
              {linkData.data.thumbnail && (
                <img
                  src={getThumbnail(
                    userSessionObj.session_data.cf_domain_name,
                    linkData.data.thumbnail,
                  )}
                  alt="link img"
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null // prevents looping
                    currentTarget.src = ImageNotFound
                  }}
                />
              )}

              <div
                style={{ marginTop: '9px', width: '76%' }}
                className="ml-4 mr-5 flex flex-column justify-content-between"
              >
                <span style={{ fontSize: '17px', fontWeight: 500 }} className="line-clamp-1">
                  {linkData.data.title}
                </span>
                <span
                  style={{ fontSize: '11.5px', color: linkData?.type === 'PAGES' ? '#0073f6' : '' }}
                  className="mt-1 line-clamp-2"
                >
                  {linkData.data.description}
                </span>
                <span style={{ fontSize: '12px' }} className="mt-2 line-clamp-1">
                  {linkData.data.other.map((info, index) => {
                    return ` ${index ? `\u00a0\u00a0` : ''} ${info.name} : ${
                      info.value
                    } \u00a0\u00a0 ${index < linkData.data.other.length - 1 ? ' | ' : ''}`
                  })}
                </span>
              </div>
              <div className="position-absolute right-2">
                <div
                  className=" h-[25px] w-[25px] rounded-full bg-[#20211c] flex justify-center items-center cursor-pointer"
                  style={{
                    boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)',
                    border: 'solid 0.5px #fff',
                  }}
                  onClick={() => openModal(linkData.type, linkData.data.id)}
                >
                  <img
                    src={EditIcon}
                    style={{
                      width: '14px',
                      height: '14px',
                    }}
                    className=""
                    alt="editicon"
                  />
                </div>
              </div>
            </div>
          </CCol>
        </CRow>
      )}

      {linkData?.type === 'TRAILER' && linkData?.data?.title && (
        <CRow className="mt-3">
          <CCol>
            <div className="trailer-link-box flex position-relative">
              {linkData.data.thumbnail && (
                <img
                  src={getVideoThumbnail(
                    userSessionObj.session_data.cf_domain_name,
                    linkData.data.thumbnail,
                  )}
                  alt="link img"
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null // prevents looping
                    currentTarget.src = ImageNotFound
                  }}
                />
              )}

              <div
                style={{ marginTop: '2px', width: '70%' }}
                className=" flex flex-column justify-content-between pl-2"
              >
                <p
                  style={{
                    fontSize: '16px',
                    fontWeight: 500,
                    wordWrap: 'break-word',
                    paddingBottom: '2px',
                    borderBottom: '0.5px solid #70707070',
                  }}
                  className="line-clamp-1 w-100 mb-0"
                >
                  {linkData.data.title}
                </p>
                <div className="d-flex w-100">
                  <div className=" w-50">
                    <p
                      style={{
                        fontSize: '10px',
                        color: '#707070',
                        fontWeight: '500',
                        marginBottom: '0.6vw',
                      }}
                      className=""
                    >
                      Size:{` `}
                      {linkData.data.size}
                    </p>

                    <p
                      style={{ fontSize: '10px', color: '#707070', fontWeight: '500' }}
                      className="mb-0"
                    >
                      Upload Date:{` `}
                      {linkData.data.uploadedDate}
                    </p>
                  </div>
                  <div className=" w-50">
                    <p
                      style={{ fontSize: '10px', color: '#707070', fontWeight: '500' }}
                      className="mb-2"
                    >
                      Resolutions Available:
                    </p>
                    <div>
                      {!isEmpty(linkData.data?.progress) &&
                        Object.keys(linkData.data?.progress)
                          .filter((ele) => linkData.data?.progress[ele] === 100)
                          .map((key, index) => {
                            return (
                              <img
                                key={index}
                                src={ResolutionsIcon[key]}
                                style={{ height: '10.5px', width: 'fit-content' }}
                                className={`${index > 0 ? 'ml-2' : ''} `}
                              />
                            )
                          })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="position-absolute right-2">
                <div
                  className=" h-[25px] w-[25px] rounded-full bg-[#20211c] flex justify-center items-center cursor-pointer"
                  style={{
                    boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)',
                    border: 'solid 0.5px #fff',
                  }}
                  onClick={() => setShowAssetManager(true)}
                >
                  <img
                    src={EditIcon}
                    style={{
                      width: '14px',
                      height: '14px',
                    }}
                    className=""
                    alt="editicon"
                  />
                </div>
              </div>
            </div>
          </CCol>
        </CRow>
      )}
      {showAssetManager && (
        <AssetManagerNew
          onCancel={() => {
            if (linkData?.type === 'TRAILER' && isEmpty(linkData.data)) {
              setSelectedEntity('')
              setLinkData({ type: '', data: {} })
            }
            setShowAssetManager(false)
          }}
          type={'TRAILER'}
          setAsset={(info) => {
            handleAssetSelect(info)
            setShowAssetManager(false)
          }}
        />
      )}
    </>
  )
}

export default AttachContent
